export default __webpack_public_path__ + "static/media/BM.7c4660d2.svg";